var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.page == "profile")?_c('profile'):_vm._e(),_vm._v(" "),(_vm.page == "coinpayments")?_c('coin-payments'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }